var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{class:['modal-close-button', _vm.wrapperClass, {}],on:{"click":[function($event){return _vm.$emit('close')},function($event){$event.stopPropagation();$event.preventDefault();return _vm.$emit('close')}]}})}
var staticRenderFns = []

export { render, staticRenderFns }